module.exports = __webpack_public_path__ + "img/handcrafted.60c8cd82a93c3c465c4ff08be9fa367d.svg";